import React, {useState, useContext} from "react";
import { htmlDecode } from "@utility/strings";
import ReviewPhotos from "@components/yotpo/ReviewPhotos.jsx"
import {YotpoContext} from '@contexts/YotpoContext.jsx';
import ThumbsUpIcon from "@assets/ThumbsUp.svg";
import ThumbsDownIcon from "@assets/ThumbsDown.svg";
import moment from "moment";
import axios from "axios";

const Review = ({review}) => {

  const [voted, setVoted] = useState(null);
  const { products } = useContext(YotpoContext);

  const avatarText = review.user.display_name.split(" ").map((name)=>{
    return name[0];
  }).filter((initial, index) => {
    return index < 2;
  }).join("");

  const star_percentage = (review.score / 5 * 100).toFixed(2);

  const vote = (type) => async () => {
    let url;
    if(voted){
      url = `https://api.yotpo.com/reviews/${review.id}/vote/${voted}/true`
      setVoted(null);
    }else{
      url = `https://api.yotpo.com/reviews/${review.id}/vote/${type}`
      setVoted(type);
    }
    const response = await axios.post(url);
  }

  let product;
  if(review.product_id){
    product = products.find((searchProduct) => {
      return searchProduct.id == review.product_id;
    });
  }

  return <div className="ft_yotpo-review">
    <div className={`ft_yotpo-review__avatar${review.verified_buyer ? " verified" : ""}`}>{avatarText}</div>
    <div className="ft_yotpo-review__main">
      <div className="ft_yotpo-review__header">
        <p className="ft_yotpo-review__date">{moment(review.created_at).format("MMM Do YYYY")}</p>
        <div className="ft_yotpo-review__name" data-user-id={review.user.user_id}><span className={`${review.verified_buyer ? " verified-buyer" : ""}`}>{review.user.display_name}</span></div>
        <div className="ft_yotpo-review__rating">
          <div className="reviews-highlight__reviews-stars" style={{"--percentage": `${star_percentage}%`}}></div>
        </div>
      </div>
      <div className="ft_yotpo-review__body">
        <div className="ft_yotpo-review__title">{htmlDecode(review.title)}</div>
        <p className="ft_yotpo-review__text">{htmlDecode(review.content)}</p>
        {review.custom_fields ?
            <ul className="ft_yotpo-review__custom-fields">
              {Object.keys(review.custom_fields).map((key) => {
                const field = review.custom_fields[key];
                return <li key={key}>{field.title}: <strong>{field.value}</strong></li>
              })}
            </ul>
          :null}
        {review.images_data ?
          <ReviewPhotos image_data={review.images_data}/>
          :null}
        <div className="ft_yotpo-review__images"></div>
      </div>
      <div className="ft_yotpo-review__footer">
        <div className="text-left">
          {product ?
            <p>
              Review of <a href={`${product.product_link}`} target="_blank">
                <strong>{product.name}</strong>
              </a>
            </p>
          : null }
        </div>
        <div className="text-right">
          <span className={`ft_yotpo-review__helpful ${voted == "up" ? "voted" : ""}`} onClick={vote("up")}>
            <span className="icon-thumbs-up">
              <ThumbsUpIcon/>
            </span>
            {voted == "up" ? review.votes_up + 1 : review.votes_up}</span>
          <span className={`ft_yotpo-review__unhelpful ${voted == "down" ? "voted" : ""}`} onClick={vote("down")}>
            <span className="icon-thumbs-down">
              <ThumbsDownIcon/>
            </span>
            {voted == "down" ? review.votes_down + 1 : review.votes_down}</span>
        </div>
      </div>
    </div>
  </div>;

}

export default Review;
